import { render, staticRenderFns } from "./SurveyWriteS2View.vue?vue&type=template&id=37d17e40"
import script from "./SurveyWriteS2View.ts?vue&type=script&lang=ts&external"
export * from "./SurveyWriteS2View.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports